import { Box } from '@chakra-ui/react';
import VFormFieldHorizontal from '@voly/ui-components/src/v2/VFormFieldHorizontal';
import { type TMentionUser } from '@voly/ui-components/src/v2/VRichText/VRichTextMention';
import VTooltip from '@voly/ui-components/src/v2/VTooltip';
import { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';
import PointFieldName from './PointFieldName';
import FieldLockedIcon from '../FieldLockedIcon';
import RichTextField from '../RichTextField';

interface PointFieldRichTextProps {
  field: TCustomField;
  value: string;
  readOnly: boolean;
  mentions?: TMentionUser[];
  onSave: (value: string, mentionIds: string[]) => void;
}

const PointFieldRichText = ({
  field,
  value,
  readOnly,
  mentions,
  onSave,
}: PointFieldRichTextProps): ReactElement => (
  <VFormFieldHorizontal
    data-testid="point-custom-field-row"
    size="sm"
    label={<PointFieldName field={field} />}
    helperText={field.description}
    errorText={undefined}
    invalid={undefined}
    readOnly={readOnly}
    disabled={field.lockedValue}
  >
    <VTooltip content={translate('locked_by_admin')} disabled={!field.lockedValue}>
      <Box data-testid="point-custom-field-control" display="flex" width="100%">
        <RichTextField
          value={value}
          readOnly={readOnly || field.lockedValue}
          placeholder={field.lockedValue ? undefined : translate('enter_text_here')}
          mentions={mentions}
          startElement={field.lockedValue ? <FieldLockedIcon /> : undefined}
          onSave={onSave}
        />
      </Box>
    </VTooltip>
  </VFormFieldHorizontal>
);

export default PointFieldRichText;
